import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../lib/api";
import TirPlanView from "../components/TirPlanView";

export default function GelenTir() {
  const { id } = useParams();
  const [plan, setPlan] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/incoming-tirs/${id}/plan`, { silent: true }).then((r) => setPlan(r.data)).catch(() => setErr("TIR BULUNAMADI")); }, [id]);
  return (
    <div data-testid="incoming-tir-page" className="space-y-2">
      <div className="text-sm font-bold text-amber-300">BANA GELEN TIR — 3D YÜKLEME PLANI (SADECE GÖRÜNTÜLEME)</div>
      {err && <div className="py-20 text-center text-slate-400">{err}</div>}
      {plan && <TirPlanView plan={plan} readOnly onReload={() => {}} />}
    </div>
  );
}
